import axiosClient from "../../../../axiosClient"

export default async (data) => {
    const result = await axiosClient.post("/inform-candidate-for-results", data)

    return result.data
}
